module.exports = __webpack_public_path__ + "img/resolve_demo_v3.5e228732.png";